import ExcavatorMountedMain from "../img/1TreeSpades/1ExcavatorMounted/BigJohn_Excavator_MainPhoto.png";
import LogoProfindoNoBG from "../img/1TreeSpades/3TruckMounted/100D/BigJohn_100D_MainPhoto.png";
import HGVGenSet from "../img/11. Hydraulics Generator/ELECTRICITY GENERATION/HGV Variable Hydraulic Generator System/PHOTOS/DYNASET_HGVVariableHydraulicGeneratorSystem_MainPhoto.png";
import VotexLCE from "../img/6. Litter Collection Equipment/546M/Votex_546M_MainPhoto.png";

const newsData = [
  {
    id: 1,
    titleKey: "news.exciting_updates_title",
    descriptionKey: "news.exciting_updates_description",
    image: LogoProfindoNoBG,
    date: "2025-01-14"
  },
  {
    id: 2,
    titleKey: "news.how_it_works_title",
    descriptionKey: "news.how_it_works_description",
    image: ExcavatorMountedMain,
    date: "2025-01-10"
  },
  {
    id: 3,
    titleKey: "news.dynaset_launching_title",
    descriptionKey: "news.dynaset_launching_description",
    image: HGVGenSet,
    date: "2025-01-05"
  },
  {
    id: 4,
    titleKey: "news.votex_launching_title",
    descriptionKey: "news.votex_launching_description",
    image: VotexLCE,
    date: "2025-01-05"
  }
];

export default newsData;
